import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = ['form']

  initialize() {
    const $ = jquery()
    if (!$) {
      return
    }

    $(this.formTarget).on('change', this.postFormToSaveChanges().bind(this))
  }

  postFormToSaveChanges() {
    return () => {
      Rails.fire(this.formTarget, 'submit')
    }
  }
}
